module.exports = __webpack_public_path__ + "static/media/logo.d00d944f.png";